import React from "react";
import { PODCAST_PLATFORMS } from "../mock";
import BrandIcon from "./BrandIcon";

function formatUsers(str) {
  const m = str.match(/^([\d.]+)([MB])/);
  if (!m) return str.replace(' Users', '');
  return `${m[1]} ${m[2] === 'B' ? 'Billion' : 'Million'}`;
}

export default function WhereHeard() {
  return (
    <section id="heard" className="relative py-20 md:py-28 px-4 md:px-8 overflow-hidden">
      <div className="relative max-w-6xl mx-auto text-center">
        <div className="text-[#f5c451] text-xs md:text-sm font-semibold tracking-[0.3em] uppercase mb-4">
          Motivation &amp; Success Network
        </div>
        <h2 className="font-display text-4xl md:text-5xl lg:text-7xl leading-[0.95] text-white">
          WHERE YOU&apos;LL BE <span className="text-gold">HEARD</span>
        </h2>
        <p className="mx-auto mt-7 text-white/65 max-w-2xl leading-relaxed text-base md:text-lg">
          Your episode goes live on the world&apos;s biggest podcast platforms, putting your voice in front of hundreds of millions of listeners. At absolutely no cost to you.
        </p>

        {/* Unified grid: icon + stat always paired per column */}
        <div className="mt-12 rounded-md border border-white/10 bg-[#080a10] overflow-hidden">
          <div className="grid grid-cols-2 sm:grid-cols-4">
            {PODCAST_PLATFORMS.map((p) => (
              <div key={p.name} className="flex flex-col bg-transparent">
                {/* Icon */}
                <div className="bg-[#080a10] flex items-center justify-center py-8 md:py-10 px-3 flex-1">
                  <BrandIcon
                    slug={p.slug}
                    customIcon={p.customIcon}
                    color={p.color}
                    iconColor={p.iconColor}
                    name={p.name}
                    size={72}
                  />
                </div>
                {/* Stat */}
                <div
                  className="text-center py-4 sm:py-5 md:py-6"
                  style={{ background: "linear-gradient(180deg, #fce181 0%, #f5c451 50%, #d6a836 100%)" }}
                >
                  <div className="font-display text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#1a0f00] leading-tight">
                    {formatUsers(p.users)}
                  </div>
                  <div className="text-[8px] sm:text-[10px] md:text-[11px] tracking-[0.22em] uppercase text-[#1a0f00]/80 font-semibold mt-1 sm:mt-1.5">
                    Listeners
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
